import React from 'react';
import classes from './FaTwitter.module.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faImage} from "@fortawesome/free-solid-svg-icons";

interface VectorIconProps {
  className?: string;
  children: React.ReactNode;
}
/* @figmaId 1:71 */
export const FaSNS = ({ className, children }: VectorIconProps) => {
  return (
    <div className={`${classes.root}`}>
        {children}
    </div>
  );
}

export const Twi = ({ className = '' }) => (
  <FaSNS className={className}>
    <a href="https://poipiku.com/1009906/" target="_blank" rel="noopener noreferrer">
    <FontAwesomeIcon style={{color:"#fff",fontSize:"2em"}} icon={faImage}/></a>
  </FaSNS>
 );
 export const Pic = ({ className = '' }) => (
  <FaSNS className={className}>
    <a href="https://www.pixiv.net/users/2287439" target="_blank" rel="noopener noreferrer">
  <svg preserveAspectRatio='none' viewBox='0 0 40 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
 <path
      d='M6.78564 1.69337e-05C5.89398 -0.00197723 5.01071 0.172177 4.18654 0.51248C3.36237 0.852784 2.61353 1.35253 1.98303 1.98303C1.35253 2.61353 0.852784 3.36237 0.51248 4.18654C0.172177 5.01071 -0.00197723 5.89398 1.69337e-05 6.78564V26.2144C-0.00197723 27.1061 0.172177 27.9893 0.51248 28.8135C0.852784 29.6377 1.35253 30.3865 1.98303 31.017C2.61353 31.6475 3.36237 32.1472 4.18654 32.4876C5.01071 32.8279 5.89398 33.002 6.78564 33H26.2144C27.1061 33.002 27.9893 32.8279 28.8135 32.4876C29.6377 32.1472 30.3865 31.6475 31.017 31.017C31.6475 30.3865 32.1472 29.6377 32.4876 28.8135C32.8279 27.9893 33.002 27.1061 33 26.2144V6.78564C33.002 5.89398 32.8279 5.01071 32.4876 4.18654C32.1472 3.36237 31.6475 2.61353 31.017 1.98303C30.3865 1.35253 29.6377 0.852784 28.8135 0.51248C27.9893 0.172177 27.1061 -0.00197723 26.2144 1.69337e-05H6.78564ZM17.5244 6.25214C20.5233 6.25214 23.1041 7.18164 24.948 8.79177C25.8669 9.58638 26.6027 10.5706 27.105 11.6767C27.6072 12.7828 27.864 13.9845 27.8575 15.1993C27.8644 17.7485 26.6475 19.9788 24.7541 21.4734C22.8635 22.9749 20.3198 23.8068 17.5244 23.8068C14.3426 23.8068 11.3919 22.649 11.3919 22.649V26.3863C11.9378 26.5458 12.8329 26.8881 12.265 27.4574H7.96127C7.39752 26.8936 8.22252 26.5636 8.84677 26.3863V10.5408C7.39889 11.6545 6.65639 12.617 6.27827 13.3334C6.71827 14.7359 5.88777 14.6658 5.88777 14.6658L4.38902 12.287C4.38902 12.287 9.70752 6.25214 17.5244 6.25214ZM17.2631 7.58727C15.3065 7.58314 12.8851 8.23764 11.3919 9.29777V21.186C12.7504 21.8556 14.8074 22.33 17.2494 22.33H17.2631C19.4576 22.33 21.3606 21.5146 22.6669 20.2221C23.9759 18.9186 24.7101 17.2205 24.7184 15.158C24.7115 13.0405 24.0254 11.22 22.7659 9.85052C21.5036 8.48652 19.6391 7.58864 17.2631 7.58727Z'
      fill='white'
    />
</svg></a>
</FaSNS>
);